/** @jsxImportSource @emotion/react */
import { TableContainer } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import ComplainHeader from "./component/complain-header";
import ComplainRow from "./component/complain-row";
import { TComplain } from "apis/meeting-room-complain";
import ComplainEmptyRow from "./component/complain-empty-row";

type PendingComplainListProps = {
  open?: boolean;
  totalPage?: number;
  nowPage?: number;
  onChangePage?: (page: number) => void;
  complainList: TComplain[];
  checkedComplainList?: TComplain[];
  onHandleCheck?: (selectedComplain: TComplain) => void;
  onHandleAllCheck?: (isChecked: boolean, complainList: TComplain[]) => void;
};

const PendingComplainList = ({
  open,
  totalPage,
  nowPage,
  onChangePage,
  complainList,
  checkedComplainList,
  onHandleCheck,
  onHandleAllCheck,
}: PendingComplainListProps) => {
  return (
    <TableContainer style={{ display: open ? "flex" : "none" }}>
      <ComplainHeader
        section="미처리 민원"
        totalCount={complainList.length}
        checkedComplainList={checkedComplainList}
        onHandleAllCheck={(isChecked) => onHandleAllCheck?.(isChecked, complainList)}
      />
      {complainList.map((complain, idx) => (
        <ComplainRow
          complain={complain}
          checkedComplainList={checkedComplainList}
          onHandleCheck={() => onHandleCheck?.(complain)}
        />
      ))}
      {complainList.length === 0 ? <ComplainEmptyRow /> : null}
      {nowPage && totalPage ? (
        <div style={{ marginTop: 48 }}>
          <UI.Pagination
            pageCount={totalPage ?? 1}
            currentPage={nowPage ?? 1}
            onChange={(page) => {
              if (page < 1) return;
              onChangePage?.(page);
            }}
          />
        </div>
      ) : null}
    </TableContainer>
  );
};
export default PendingComplainList;
